import { useI18n } from '../lib/i18n';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { useTheme } from '../lib/theme';
import { useEffect } from 'react';

export default function LoginPage() {
  const { t } = useI18n();
  const { user, signIn, loading } = useAuth();
  const { mode } = useTheme();
  const logo = mode === 'light' ? '/gri-institute-logo.svg' : '/gri-institute-logo-white.svg';
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate('/', { replace: true });
  }, [user, navigate]);

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'var(--bg)' }}>
        <div style={{ width:48, height:48, border:'4px solid var(--border)', borderTopColor:'var(--gold)', borderRadius:'50%', animation:'spin 1s linear infinite' }} />
      </div>
    );
  }

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh', background:'var(--bg)', padding:'24px' }}>
      <div style={{ width:'100%', maxWidth:'400px', background:'var(--card)', border:'1px solid var(--border)', borderRadius:'16px', padding:'40px 32px', boxShadow:'0 25px 50px -12px rgba(0,0,0,0.5)', display:'flex', flexDirection:'column', alignItems:'center' }}>
        <div style={{ marginBottom:32, display:'flex', flexDirection:'column', alignItems:'center' }}>
          <img src={logo} alt="GRI Institute" style={{ height:32, width:'auto', display:'block', marginBottom:8 }} />
          <div style={{ fontSize:11, fontWeight:600, color:'var(--gold)', letterSpacing:'0.08em', textTransform:'uppercase' }}>{t('app_title')}</div>
        </div>

        <button
          onClick={signIn}
          style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'center', gap:12, padding:'14px 24px', background:'#fff', color:'#333', fontWeight:500, fontSize:15, borderRadius:10, border:'none', cursor:'pointer' }}
          onMouseEnter={e => (e.currentTarget.style.background = '#f1f1f1')}
          onMouseLeave={e => (e.currentTarget.style.background = '#fff')}
        >
          <svg style={{ width:20, height:20, flexShrink:0 }} viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Continuar com Google
        </button>
        <p style={{ fontSize:12, color:'var(--muted)', opacity:0.6, marginTop:20, textAlign:'center' }}>Acesso restrito a contas @griinstitute.org</p>
      </div>
    </div>
  );
}
